import { SectionBox, inputCls } from "../shared";

type Props = {
  body: string;
  onBodyChange: (value: string) => void;
};

export default function BasicTextFields({ body, onBodyChange }: Props) {
  const newlineCount = (body.match(/\n/g) || []).length;

  return (
    <SectionBox label="홍보문구" required>
      <label className="tw-block tw-text-xs tw-text-gray-500">
        <span className="tw-text-red-500 tw-mr-1">*</span>
        홍보문구
      </label>
      <textarea
        rows={6}
        maxLength={1300}
        value={body}
        onChange={(e) => {
          const nextValue = e.target.value;
          if ((nextValue.match(/\n/g) || []).length > 99) return;
          onBodyChange(nextValue);
        }}
        placeholder="홍보문구를 입력하세요."
        className={`${inputCls} tw-resize-none`}
      />
      <div className="tw-flex tw-justify-end tw-gap-4 tw-text-xs tw-text-gray-400">
        <span>개행 {newlineCount} / 99</span>
        <span>{body.length} / 1300</span>
      </div>
    </SectionBox>
  );
}
